import {
  type DataBindingController,
  type DataBindingControllerConnection,
} from '../types'

export const getControllerConnectionsToComponent = ({
  controller,
  componentId,
}: {
  controller: DataBindingController
  componentId: string
}): DataBindingControllerConnection[] => {
  const connections = controller.custom.relatedConnections[componentId]
  if (connections === undefined) {
    throw new Error(`No connection to component with ID "${componentId}".`)
  }
  return connections
}
